
    import './styles.scoped.css';
    export default {
  "card-inner": "awsui_card-inner_p8a6i_udli1_97",
  "root": "awsui_root_p8a6i_udli1_117",
  "header-variant-full-page": "awsui_header-variant-full-page_p8a6i_udli1_133",
  "header-refresh": "awsui_header-refresh_p8a6i_udli1_133",
  "list": "awsui_list_p8a6i_udli1_149",
  "list-grid-1": "awsui_list-grid-1_p8a6i_udli1_157",
  "card": "awsui_card_p8a6i_udli1_97",
  "list-grid-2": "awsui_list-grid-2_p8a6i_udli1_160",
  "list-grid-3": "awsui_list-grid-3_p8a6i_udli1_163",
  "list-grid-4": "awsui_list-grid-4_p8a6i_udli1_166",
  "list-grid-5": "awsui_list-grid-5_p8a6i_udli1_169",
  "list-grid-6": "awsui_list-grid-6_p8a6i_udli1_172",
  "list-grid-7": "awsui_list-grid-7_p8a6i_udli1_175",
  "list-grid-8": "awsui_list-grid-8_p8a6i_udli1_178",
  "list-grid-9": "awsui_list-grid-9_p8a6i_udli1_181",
  "list-grid-10": "awsui_list-grid-10_p8a6i_udli1_184",
  "list-grid-11": "awsui_list-grid-11_p8a6i_udli1_187",
  "list-grid-12": "awsui_list-grid-12_p8a6i_udli1_190",
  "list-grid-13": "awsui_list-grid-13_p8a6i_udli1_193",
  "list-grid-14": "awsui_list-grid-14_p8a6i_udli1_196",
  "list-grid-15": "awsui_list-grid-15_p8a6i_udli1_199",
  "list-grid-16": "awsui_list-grid-16_p8a6i_udli1_202",
  "list-grid-17": "awsui_list-grid-17_p8a6i_udli1_205",
  "list-grid-18": "awsui_list-grid-18_p8a6i_udli1_208",
  "list-grid-19": "awsui_list-grid-19_p8a6i_udli1_211",
  "list-grid-20": "awsui_list-grid-20_p8a6i_udli1_214",
  "selection-control": "awsui_selection-control_p8a6i_udli1_218",
  "loading": "awsui_loading_p8a6i_udli1_227",
  "empty": "awsui_empty_p8a6i_udli1_228",
  "has-header": "awsui_has-header_p8a6i_udli1_235",
  "card-header": "awsui_card-header_p8a6i_udli1_272",
  "card-header-inner": "awsui_card-header-inner_p8a6i_udli1_278",
  "card-selectable": "awsui_card-selectable_p8a6i_udli1_282",
  "card-selected": "awsui_card-selected_p8a6i_udli1_285",
  "section": "awsui_section_p8a6i_udli1_294",
  "section-header": "awsui_section-header_p8a6i_udli1_300",
  "section-content": "awsui_section-content_p8a6i_udli1_306"
};
  